/*
Lalitha 12/19/2022  3075154998 Added Search Data Manager Record Table
Lalitha 12/20/2022  3075154998 Added Created Date in Data Manager Record Table
Lalitha 12/21/2022  3075154998 Integrated search Api
Lalitha 12/22/2022  3075154998 Integrated Delete Api
Sohel 12/22/2022 3075154998 fixed toast message issue.
Sohel 12/28/2022 3075154998 Added edit icon.
Sohel  12/29/2022 3075154998 Added Export Manager record Screen
Sohel 01/03/2022 3075154998 Map Record Group Changes
Sohel  03/01/2022 3075154998 label Changes
dilip 01/09/2023 3075154998 Added search data local storage
Sohel 01/10/2023 2699388043 Implemented Copy Functionality
Sohel 01/11/2023 2699388043 Added isDraft in Export
dilip 01/11/2023 2699388043 payload change
Sohel 01/11/2023 2699389646 implement System notes functionality
Sohel 01/12/2023 3075154998 Added download configuration
Dilip 01/13/2023 3075154998 addded code in delete popup
Akhila 01/16/2023 3075154998 Disable Download configuration button when there is no table Data
Sohel 01/18/2023 3075154998 fixed reset Issue
Sohel 01/18/2023 3075154998 Download Configuration Payload Changes
Sohel 01/18/2023 2698951347 Fixed Status  issue
Sohel 01/20/2023 2699389646 Added Last Step in Stepper
sai krishna 01/20/2023 2698951347 renamed notes tooltip
Sohel 01/20/2023 2698951347 Fixed page break issue
Sohel 01/23/2023 2698951347 fixed length populate issue
Ashraf 01/27/2023 2698951347 added new columns audit and category
Sohel 01/31/2023 2698951347 label changes
Dilip 01/31/2023 2698951347 label and title changes
sai krishna 02/01/2023 2698951347 updated payload
Sohel 02/01/2023 2698964415 set record Type
sai krishna 02/02/2023 2698964415 updated print Api payload
Sohel 01/08/2023 2701335619 Implemented Usage Functionality
Sohel 02/08/2023 2701335619 Implement Usage Functionality
Ravi 02/09/2023 2701335619 Added used in Usage Toast Messege
Dilip 02/09/2023 2701335619 added creted for and creted by column and payload changes
Sohel 02/20/2023 2701335619 Download Configuration Payload Changes
Raghu 02/23/2023 2701335619 added new class for buttons
Sohel 02/24/2023 2698964415 usage popup title changes
Dilip 02/24/2023 2701335619 implemented preview file functionality in download configuration
Dilip 02/27/2023 2701335619 Fixed Sorting issue
Dilip 02/28/2023 2698964415 payload change
Ravi 03/01/2023 2698964415 Added loader and download toast message for preview File
T Santosh Kumar 15/03/2023 2698964415 Responsive UI Changes
Raghu 03/15/2023 2698964415 fixed table actions
Raghu 03/16/2023 2698964415 fixed table action
Raghu 03/04/2023 2698964415 added plus icon
Akhila 05/04/2023 2698964415 Added update date column and in payload
Ravi 05/31/2023 2698964415  changed delete popup message
Akhila 06/06/2023 2698964415 added code and description in action
Akhila 06/08/2023 2698964415 title label placeholder name change
Akhila 06/08/2023 2698964415 rearrange the column and form fields
Sohel 12/12/2023 2701335619 column name change code to name 
*/

import React, {createRef, useState, useEffect, useRef} from 'react';
import {TablePagination, Grid, Button, makeStyles} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import moment from 'moment';
import PageLoader from '../../../../../components/PageLoader';
import {useUpdateEffect} from 'react-use';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {
  fetchBasicInfoData,
  fetchDataManagerRecordUsage,
  postPrintImportRecordGroup,
  resetBasicInfo,
  resetBasicInfoRecord,
  resetDataManagerRecord,
  resetDataManagerRecordUsage,
  setDraftStatusRedux,
  setFixedLengthRedux,
  setLastStepRedux,
  resetConfigUrl,
  resetDockey,
  setHeaderLinesRedux,
} from '../../../../../redux/reducers/DataManagerRecord';
import {
  ErrorSnackbar,
  SuccessSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import DialogBox from '../../../../../components/DialogBox';
import CopyDataManagerRecord from '../../DataManagerRecord/SearchDataManagerRecord/CopyDataManagerRecord';
import ExportManagerRecordNotes from '../../DataManagerRecord/SearchDataManagerRecord/ImportManagerRecordNotes';
import {setRecordGroupRedux} from '../../../../../redux/reducers/DataManagerRecordGroup';
import UsageMessage from '../../../../../util/UsageMessage';
import OverrideRule from '../../../../../components/OverrideRule';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import {downloadButton} from '../../../../../util/Content';
import axios from 'axios';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import AddIcon from '@material-ui/icons/AddOutlined';
const useStyles = makeStyles((theme) => ({
  'link': {
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));

function SearchDMRecordTable({
  setValue = () => {},
  searchData,
  submit,
  setSubmit,
  setEditExisting,
  isMapRecordGroup,
  dmTempRecordAccess,
  setDataManagerRecordData = () => {},
}) {
  const tableRef = createRef();
  const queryRef = useRef(null);
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const dispatch = useDispatch();
  const classes1 = useStyles();
  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [status, setStatus] = useState(false);
  const [copyDataManagerRecord, setCopyDataManagerRecord] = useState(false);
  const [oldDmrCodeData, setOldDmrCodeData] = useState(null);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [isNote, setIsNote] = useState(false);
  const [dmrData, setDmrData] = useState();
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isUsage, setIsUsage] = useState(false);

  const {
    basicInfoSuccessMsg,
    basicInfoErrorMsg,
    isBasicInfoLoading,
    basicInfoStatus,
    dataManagerRecordUsage,
    configurationUrl,
    dockey,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const [resultCount, setResultCount] = useState(0);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  const [loading, setIsLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  const deletedId = useRef(null);
  const onEditCall = (rowData) => {
    dispatch(
      setDraftStatusRedux({
        property: 'isDraftRecord',
        value: rowData.isDraft,
      }),
    );
    dispatch(
      setLastStepRedux({
        property: 'lastStep',
        value: rowData.lastStep,
      }),
    );
    dispatch(
      setFixedLengthRedux({
        property: 'fixedLength',
        value: rowData?.fixedLength,
      }),
    );
    dispatch(
      setRecordGroupRedux({
        property: 'recordType',
        value: {value: rowData?.recordType},
      }),
    );
  };
  const columns = [
    {
      title: 'Category',
      field: 'category',
      render: (rowData) => {
        return rowData?.category === 'CL' ?
          'CL - Client' :
          rowData?.category === 'CO' ?
            'CO - Core' :
            rowData?.category === 'PA' ?
              'PA - Payment' :
              '';
      },
    },
    {
      title: 'Export Template Record Name',
      field: 'recordCode',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            setEditExisting('Export');
            onEditCall(rowData);
            dispatch(fetchBasicInfoData(rowData?.dataManagerRecordId));
            setValue(1);
          }}
        >
          {rowData?.recordCode?.replace(/ /g, '\u00a0')}
        </span>
      ),
    },
    {
      title: 'Export Template Description',
      field: 'recordDescription',
      render: (rowData) => rowData?.recordDescription?.replace(/ /g, '\u00a0')
    },

    {
      title: 'Record Type',
      field: 'recordType',
    },
    {
      title: 'Include Audit',
      field: 'includeAudit',
      render: (rowData) =>
        rowData?.includeAudit === 'Y' ? 'Y - Yes' : rowData?.includeAudit === 'N' ? 'N - No' : '',
    },
    {
      title: 'Created For',
      field: 'createdFor',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Updated Date',
      field: 'updatedDate',
      render: (rowData) => {
        return rowData?.updatedDate ?
          moment(rowData?.updatedDate).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Draft</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Completed</span>
          </div>
        ),
    },
  ];

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  const handleEdit = (rowData) => {
    setEditExisting('Export');
    onEditCall(rowData);
    dispatch(fetchBasicInfoData(rowData?.dataManagerRecordId));
    setValue(1);
  };
  const handleCopy = (rowData) => {
    setOldDmrCodeData(rowData);
    setCopyDataManagerRecord(true);
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setDmrData(rowData);
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setDataManagerRecordData(rowData);
    dispatch(fetchDataManagerRecordUsage('Export', rowData.dataManagerRecordId));
  };
  const handleDelete = (rowData) => {
    dispatch(fetchDataManagerRecordUsage('Export', rowData.dataManagerRecordId));
    setIsDelete(false);
    setDeleteUsage(true);
    deletedId.current = rowData;
  };
  useEffect(() => {
    dispatch(resetDataManagerRecord());
    dispatch(resetBasicInfoRecord());
    dispatch(
      setDraftStatusRedux({
        property: 'isDraftRecord',
        value: '',
      }),
    );
    dispatch(
      setLastStepRedux({
        property: 'lastStep',
        value: 0,
      }),
    );
    dispatch(
      setFixedLengthRedux({
        property: 'fixedLength',
        value: '',
      }),
    );
    dispatch(
      setRecordGroupRedux({
        property: 'recordType',
        value: {},
      }),
    );
    dispatch(
      setHeaderLinesRedux({
        property: 'headerLines',
        value: null,
      }),
    );
  }, []);
  const handleCopyDataManagerRecord = () => {
    setCopyDataManagerRecord(false);
  };
  const handleCloseNotesDialog = () => {
    setIsNote(false);
  };
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 1500);
    }
  }, [tstmsg, deleteErrorMsg]);
  useEffect(() => {
    if (basicInfoErrorMsg || basicInfoSuccessMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);
  useEffect(() => {
    if (basicInfoStatus === 200 && basicInfoSuccessMsg) {
      if (oldDmrCodeData?.isDraft) {
        dispatch(
          setDraftStatusRedux({
            property: 'isDraftRecord',
            value: oldDmrCodeData?.isDraft ? oldDmrCodeData?.isDraft : '',
          }),
        );
      }
      setTimeout(() => {
        dispatch(resetBasicInfo());
        setValue(1);
      }, 1500);
    }
  }, [basicInfoStatus, basicInfoSuccessMsg]);
  const handleClose = () => {
    setIsDelete(false);
    setUserMetrixDelete(false);
  };

  const handleSubmit = () => {
    httpPaginationDelete(
        `data-manager/record/delete/record/${deletedId.current?.dataManagerRecordId}`,
    )
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedForDropDownData('exporttemplaterecord'));
      dispatch(fetchCreatedByDropDownData('exporttemplaterecord'));
      setStatus(false);
    }
  }, [status]);

  const EMRecordSessionStorage = JSON.parse(sessionStorage.getItem('EMRecord'));
  if (EMRecordSessionStorage && !submit) {
    searchData = EMRecordSessionStorage;
  }
  useEffect(() => {
    dispatch(
      setDraftStatusRedux({
        property: 'isDraftRecord',
        value: '',
      }),
    );
  }, []);
  useEffect(() => {
    if (dataManagerRecordUsage?.userMetrix === 'No') {
      if (deleteUsage) {
        setUserMetrixDelete(false);
        setIsDelete(true);
      } else {
        setCustomError(true);
        setTimeout(() => {
          setCustomError(false);
          dispatch(resetDataManagerRecordUsage());
        }, 3000);
      }
    } else if (dataManagerRecordUsage?.userMetrix === 'Yes') {
      if (deleteUsage) {
        setIsDelete(true);
        setUserMetrixDelete(true);
      } else {
        setValue(2);
      }
    }
  }, [dataManagerRecordUsage]);
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      setIsUsage(true);
      setIsDelete(false);
      setUserMetrixDelete(false);
    } else {
      handleSubmit();
    }
  };
  useEffect(() => {
    setCustomError(false);
    setValue(0);
    isDelete && setIsDelete(false);
  }, []);
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Export Template Record'}
      />
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title={userMetrixDelete ? 'Export Template Records Usage' : 'Delete Export Template Record'}
        value={
          userMetrixDelete ? (
            <UsageMessage value={'Export Template Record'} />
          ) : (
            `Are you sure want to delete the ${deletedId.current?.recordCode?.replace(/ /g, '\u00a0')} Export Template Record?`
          )
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleDeleteUsage}
      />
      <OverrideRule
        dialogTitle="Export Template Record Usage"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title={`${deletedId.current?.recordCode?.replace(/ /g, '\u00a0') || ''} - ${
          deletedId.current?.recordDescription?.replace(/ /g, '\u00a0') || ''
        } Export Template Record has been used in the following Exports.`}
        data={dataManagerRecordUsage?.placeResponse}
        isOverRide={false}
      />
      <DialogBox
        open={copyDataManagerRecord}
        dialogClose={handleCopyDataManagerRecord}
        title={`Copy Export Template Record `}
        maxWidth="md"
        hideFooter={true}
      >
        <CopyDataManagerRecord oldDmrCodeData={oldDmrCodeData} type={'Export'} />
      </DialogBox>
      <DialogBox
        open={isNote}
        dialogClose={handleCloseNotesDialog}
        title="Export Template Record Notes"
        maxWidth="lg"
      >
        <ExportManagerRecordNotes
          dmTempRecordAccess={dmTempRecordAccess}
          dmrData={dmrData}
          type={'Export'}
        />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon new-standard-textfields actions-dropdown-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-manager/record/search/all`;

                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  recordCode: searchData?.code ? searchData?.code : '',
                  recordType: searchData?.recordType?.value ? [searchData?.recordType?.value] : [],
                  recordDescription: searchData?.recordDescription ?
                    searchData?.recordDescription :
                    '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdFor: searchData?.createdFor?.userLoginName ?
                    searchData?.createdFor?.userLoginName :
                    '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  type: 'Export',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  masterRecord: '',
                  includeAudit: searchData?.includeAudit?.key ? searchData?.includeAudit?.key : '',
                  category: searchData?.category?.categoryCode ?
                    searchData?.category?.categoryCode :
                    '',
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                        setResultCount(response?.data?.response?.count);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: !isMapRecordGroup,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              selection: isMapRecordGroup,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => <SaveIcon />,
                tooltip: 'Save User',
                onClick: (event, rowData) => console.log(rowData, 'rowData'),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer pagination-block">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      disabled={Boolean(resultCount === 0)}
                      onClick={(event) => {
                        dispatch(
                          postPrintUsage({
                            baseCategory: '',
                            code: '',
                            description: '',
                            displayName: '',
                            fileType: '',
                            recordFormatType: '',
                            returnType: '',
                            sourceType: 'EXPORT TEMPLATE RECORD',
                            isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                            masterRecord: '',
                            search: '',
                            frameworkUsageOrderBy: '',
                            frameworkUsageOrderDerection: '',
                            createdBy: searchData?.createdBy?.userLoginName ?
                              searchData?.createdBy?.userLoginName :
                              '',
                            createdFor: searchData?.createdFor?.userLoginName ?
                              searchData?.createdFor?.userLoginName :
                              '',
                            fieldListOrderBy:
                              queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                queryRef.current.orderBy.field :
                                '',
                            fieldListOrderDerection: queryRef.current?.orderDirection ?
                              queryRef.current?.orderDirection :
                              '',
                            category: searchData?.category?.categoryCode ?
                              searchData?.category?.categoryCode :
                              '',
                            fieldName: '',
                            repositoryDescription: '',
                            repositoryName: '',
                            repositoryType: '',
                            recordCode: searchData?.code ? searchData?.code : '',
                            recordDescription: searchData?.recordDescription ?
                              searchData?.recordDescription :
                              '',
                            recordType: searchData?.recordType?.value ?
                              searchData?.recordType?.value :
                              '',
                            createdDate: searchData?.createdDate ?
                              moment(searchData?.createdDate).format('MM/DD/YYYY') :
                              '',
                            includeAudit: searchData?.includeAudit?.key ?
                              searchData?.includeAudit?.key :
                              '',
                          }),
                        );
                      }}
                    >
                      Download Configuration Usage
                    </Button>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn ml-2 ${classes1.buttonRoot}`}
                      disabled={resultCount === 0}
                      onClick={() => {
                        dispatch(
                          postPrintImportRecordGroup(
                            {
                              recordCode: searchData?.code ? searchData?.code : '',
                              recordType: searchData?.recordType?.value ?
                                [searchData?.recordType?.value] :
                                [],
                              createdBy: searchData?.createdBy?.userLoginName ?
                                searchData?.createdBy?.userLoginName :
                                '',
                              createdFor: searchData?.createdFor?.userLoginName ?
                                searchData?.createdFor?.userLoginName :
                                '',
                              recordDescription: searchData?.recordDescription ?
                                searchData?.recordDescription :
                                '',
                              createdDate: searchData?.createdDate ?
                                moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                '',
                              orderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                  queryRef.current.orderBy.field :
                                  '',
                              orderDirection: queryRef.current?.orderDirection ?
                                queryRef.current?.orderDirection :
                                '',
                              isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                              type: 'Export',
                              includeAudit: searchData?.includeAudit?.key ?
                                searchData?.includeAudit?.key :
                                '',
                              category: searchData?.category?.categoryCode ?
                                searchData?.category?.categoryCode :
                                '',
                            },
                            'Export',
                          ),
                        );
                      }}
                    >
                      {downloadButton}
                    </Button>
                  </div>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleUsage={handleUsage}
                  // handleRun={handleRun}
                  // handleExecution={handleExecution}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: props?.data?.repositoryType === 'SYSTEM',
                    run: true,
                    copy: isMapRecordGroup,
                    hiddenDelete: isMapRecordGroup,
                    notes: isMapRecordGroup,
                    execution: true,
                    usage: false,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: !dmTempRecordAccess?.edit,
                    disableRun: false,
                    disableCopy: !dmTempRecordAccess?.add,
                    disableDelete: !dmTempRecordAccess?.delete,
                    disableNotes: false,
                    disableExecution: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {/* {mapRecord && ( */}
                    <Button
                      type="button"
                      variant="outlisetOpenned"
                      className={`mx-1 search-btn`}
                      disabled={!dmTempRecordAccess?.add}
                      isFreeAction={true}
                      onClick={(event) => {
                        setValue(1);
                        dispatch(resetDataManagerRecord());
                        dispatch(
                          setDraftStatusRedux({
                            property: 'isDraftRecord',
                            value: '',
                          }),
                        );
                        dispatch(
                          setLastStepRedux({
                            property: 'lastStep',
                            value: 0,
                          }),
                        );
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Export Template Record
                    </Button>
                    {/* )} */}
                  </div>
                </div>
              ),
            }}

            // actions={
            //   isMapRecordGroup
            //     ? []
            //     : [
            //         {
            //           icon: () => (
            //             <>
            //               <Button type="button" variant="outlined" className={`search-btn`}>
            //                 Add Record
            //               </Button>
            //             </>
            //           ),
            //           isFreeAction: true,
            //           onClick: () => {
            //             setValue(1);
            //             dispatch(resetDataManagerRecord());
            //             dispatch(
            //               setDraftStatusRedux({
            //                 property: "isDraftRecord",
            //                 value: "",
            //               })
            //             );
            //             dispatch(
            //               setLastStepRedux({
            //                 property: "lastStep",
            //                 value: 0,
            //               })
            //             );
            //           },
            //         },
            //         {
            //           icon: () => <EditOutlinedIcon />,
            //           tooltip: "Edit",
            //           onClick: (event, rowData) => {
            //             onEditCall(rowData);
            //             dispatch(fetchBasicInfoData("Export", rowData?.recordCode));
            //             setValue(1);
            //           },
            //         },
            //         {
            //           icon: () => (
            //             <>
            //               <FileCopyOutlinedIcon />
            //             </>
            //           ),
            //           tooltip: "Copy",
            //           onClick: (event, rowData) => {
            //             setOldDmrCodeData(rowData);
            //             setCopyDataManagerRecord(true);
            //           },
            //         },
            //         {
            //           icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
            //           tooltip: "Usage",
            //           onClick: (event, rowData) => {
            //             setDeleteUsage(false);
            //             setDataManagerRecordData(rowData);
            //             dispatch(fetchDataManagerRecordUsage("Export", rowData.recordCode));
            //           },
            //         },
            //         (rowData) => {
            //           return {
            //             icon: () => (
            //               <>
            //                 <DeleteOutlineOutlinedIcon />
            //               </>
            //             ),
            //             tooltip: "Delete",
            //             onClick: () => {
            //               handleDelete(rowData);
            //             },
            //           };
            //         },
            //         {
            //           icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //           tooltip: "Export Template Record Notes",
            //           onClick: (event, rowData) => {
            //             setIsNote(true);
            //             setDmrData(rowData?.recordCode);
            //           },
            //         },
            //       ]
            // }
          />
        </div>
      </Grid>
      {(loading || printUsageIsLoading || isBasicInfoLoading) && <PageLoader />}
      {(deleteErrorMsg || basicInfoErrorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={deleteErrorMsg || basicInfoErrorMsg || printUsageErrorMsg} />
      )}
      {(tstmsg || basicInfoSuccessMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={tstmsg || basicInfoSuccessMsg || printUsageSuccessMsg} />
      )}
      {customError && (
        <WarningSnackbar errorMsg={`This Export Template Record is not being used anywhere`} />
      )}
    </>
  );
}

export default SearchDMRecordTable;
